module.exports = __webpack_public_path__ + "img/check2-square.1a28be8d.svg";